"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../../../constants/colors"));

var _vars = _interopRequireDefault(require("../../../../constants/vars"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t\tcolor: ", "\n\t\tcursor: ", ";\n\t\tuser-select: none;\n\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex: 1 ", ";\n\tmargin: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tflex: 1 0 auto\n\tfont-weight: bold;\n\tfont-family: ", ";\n\tcolor: ", ";\n\tmargin: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Text = _styledComponents.default.span(_templateObject(), _vars.default.fontStackBold, _colors.default.borderColor, function (_ref) {
  var position = _ref.position;
  return position === 'start' ? '0 10px 0 0' : '0 0 0 10px';
});

Text.displayName = 'Text'; // need display:flex here to fix Safari layout issue caused by react-icon-base setting vertical-align: middle

var IconWrapper = _styledComponents.default.div(_templateObject2(), function (_ref2) {
  var iconSize = _ref2.iconSize;
  return iconSize + "px";
}, function (_ref3) {
  var position = _ref3.position;
  return position === 'start' ? '0 10px 0 0' : '0 0 0 10px';
});

IconWrapper.displayName = 'IconWrapper';

var Adornment = function Adornment(_ref4) {
  var element = _ref4.element,
      disabled = _ref4.disabled,
      position = _ref4.position,
      size = _ref4.size;

  if (typeof element === 'string') {
    return _react.default.createElement(Text, {
      position: position
    }, element);
  }

  var Icon = (0, _styledComponents.default)(element.icon)(_templateObject3(), function (props) {
    return props.disabled ? _colors.default.disabled : element.color;
  }, function (props) {
    return props.disabled ? 'default' : 'pointer';
  });
  Icon.displayName = 'Icon';
  return _react.default.createElement(IconWrapper, {
    position: position,
    iconSize: size === 'small' ? 18 : 22
  }, _react.default.createElement(Icon, {
    role: "button",
    disabled: disabled,
    size: size === 'small' ? 18 : 22,
    onClick: disabled ? undefined : element.onClick
  }));
};

Adornment.propTypes = {
  element: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
    icon: _propTypes.func.isRequired,
    onClick: _propTypes.func.isRequired,
    color: _propTypes.string
  })]).isRequired,
  disabled: _propTypes.bool,
  position: (0, _propTypes.oneOf)(['start', 'end']).isRequired,
  size: (0, _propTypes.oneOf)(['small', 'regular']).isRequired
};
Adornment.defaultProps = {
  disabled: _propTypes.bool
};
var _default = Adornment;
exports.default = _default;